import React, {Fragment} from 'react';
import GiftCardMessage from '../GiftCard/GiftCardMessage/GiftCardMessage';
import GiftCardForm from './GiftCardForm/GiftCardForm';
import './GiftCard.less';

export default function GiftCard(props) {
    return (
        <Fragment>
            <div className="GiftCardMessage__Image"/>
            <div className="GiftCardExamples">
                <GiftCardMessage />
                <GiftCardForm {...props}/>
            </div>
        </Fragment>
    );
}
